import { Component, Vue } from 'vue-property-decorator';
import lodash from 'lodash';
import { CONTRIBUTION_LEVELS } from '@/constants';
import { SummaryLevelCount } from '@/models';
import { fetchSummaryLevels } from '@/services';
import ContributionLevelIcon from '@/components/common/contribution-level-icon/ContributionLevelIcon.vue';

@Component({
  components: {
    ContributionLevelIcon
  }
})
export default class SummaryLevels extends Vue {
  private levels = Object.values(CONTRIBUTION_LEVELS);

  private summaryLevels = {} as SummaryLevelCount;

  toCamelCase(text: string): string {
    return lodash.camelCase(text);
  }

  async created(): Promise<void> {
    const { data } = await fetchSummaryLevels();
    this.summaryLevels = data;
  }
}
